import * as React from 'react';
import { Textarea } from './Textarea';
import { IValidation } from '../../../utils/Validation';
import './TextareaField.css';

type TextAreaFieldProps = Omit<React.ComponentProps<typeof Textarea>, 'onChange' | 'validation'> & {
	onChange?: (e: any) => void;
	validation?: IValidation;
};

const TextAreaField: React.FC<TextAreaFieldProps> = ({ onChange = () => {}, validation, ...props }) => (
	<Textarea {...props} onChange={onChange} validation={validation as IValidation} />
);

export default TextAreaField;
